import { render, staticRenderFns } from "./transformOrder.vue?vue&type=template&id=1ae636a0&scoped=true&"
import script from "./transformOrder.vue?vue&type=script&lang=js&"
export * from "./transformOrder.vue?vue&type=script&lang=js&"
import style0 from "./transformOrder.vue?vue&type=style&index=0&id=1ae636a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae636a0",
  null
  
)

export default component.exports